export default {"src":"/_next/static/media/checkbox-unselected.7b411bcb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};